import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { pulseIdentityApiToEntity } from '../../entities/PulseIdentity/converters';
import { pagingMetadataToCursorResponse } from '../../utils/PagingUtils';
import { BaseClient } from '../BaseClient';
const UPDATABLE_FIELDS = ['name', 'description', 'soul', 'heartbeat', 'triggers', 'cron', 'autoMode'];
export class PulseIdentityClientBase extends BaseClient {
  constructor() {
    super(...arguments);
    _defineProperty(this, "createPulseIdentityImpl", void 0);
    _defineProperty(this, "getPulseIdentityImpl", void 0);
    _defineProperty(this, "updatePulseIdentityImpl", void 0);
    _defineProperty(this, "deletePulseIdentityImpl", void 0);
    _defineProperty(this, "queryPulseIdentitiesImpl", void 0);
  }
  getServiceNameForLogs() {
    return 'PulseIdentityClient';
  }
  async createPulseIdentity(pulseIdentity) {
    try {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }
      const {
        pulseIdentity: created
      } = await this.request(this.createPulseIdentityImpl({
        pulseIdentity: pulseIdentity
      }), ...args);
      if (!created) {
        throw new Error('Invalid pulse identity response');
      }
      return this.convertToEntity(created);
    } catch (error) {
      this.logError('createPulseIdentity', 'Failed to create pulse identity', {
        pulseIdentity
      }, error);
      throw error;
    }
  }
  async getPulseIdentity(pulseIdentityId) {
    try {
      for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        args[_key2 - 1] = arguments[_key2];
      }
      const {
        pulseIdentity
      } = await this.request(this.getPulseIdentityImpl({
        pulseIdentityId
      }), ...args);
      if (!pulseIdentity) {
        throw new Error('Pulse identity not found');
      }
      return this.convertToEntity(pulseIdentity);
    } catch (error) {
      this.logError('getPulseIdentity', 'Failed to get pulse identity', {
        pulseIdentityId
      }, error);
      throw error;
    }
  }
  async updatePulseIdentity(pulseIdentityId, revision, updates) {
    try {
      const fieldMask = UPDATABLE_FIELDS.filter(field => updates[field] !== undefined);
      if (fieldMask.length === 0) {
        throw new Error('No fields to update');
      }
      const pulseIdentity = {
        id: pulseIdentityId,
        revision,
        ...updates
      };
      for (var _len3 = arguments.length, args = new Array(_len3 > 3 ? _len3 - 3 : 0), _key3 = 3; _key3 < _len3; _key3++) {
        args[_key3 - 3] = arguments[_key3];
      }
      const {
        pulseIdentity: updated
      } = await this.request(this.updatePulseIdentityImpl({
        pulseIdentity,
        fieldMask
      }), ...args);
      if (!updated) {
        throw new Error('Invalid pulse identity response');
      }
      return this.convertToEntity(updated);
    } catch (error) {
      this.logError('updatePulseIdentity', 'Failed to update pulse identity', {
        pulseIdentityId,
        fieldMask: Object.keys(updates)
      }, error);
      throw error;
    }
  }
  async deletePulseIdentity(pulseIdentityId) {
    try {
      for (var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
        args[_key4 - 1] = arguments[_key4];
      }
      await this.request(this.deletePulseIdentityImpl({
        pulseIdentityId
      }), ...args);
    } catch (error) {
      this.logError('deletePulseIdentity', 'Failed to delete pulse identity', {
        pulseIdentityId
      }, error);
      throw error;
    }
  }
  async queryPulseIdentities(query) {
    try {
      for (var _len5 = arguments.length, args = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
        args[_key5 - 1] = arguments[_key5];
      }
      const {
        pulseIdentities,
        pagingMetadata
      } = await this.request(this.queryPulseIdentitiesImpl({
        query: query
      }), ...args);
      if (!pulseIdentities) {
        throw new Error('Received invalid pulse identities');
      }
      return {
        items: pulseIdentities.map(p => this.convertToEntity(p)),
        ...pagingMetadataToCursorResponse(pagingMetadata)
      };
    } catch (error) {
      this.logError('queryPulseIdentities', 'Failed to query pulse identities', {
        query
      }, error);
      throw error;
    }
  }
  convertToEntity(pulseIdentityApi) {
    return pulseIdentityApiToEntity(pulseIdentityApi);
  }
}
//# sourceMappingURL=PulseIdentityClientBase.js.map